export function isPendingApplication(item) {
  const status = Number(item && item.applyStatus)
  return status >= 1 && status <= 5
}

export function isPendingInvitation(item) {
  const status = Number(item && item.status)
  return status === 2 || status === 3
}

export function isPendingOrder(item) {
  if (!item || item.closed) return false
  if (item.closeRequested) return true
  const fulfillment = Number(item.fulfillmentStatus)
  const settlement = Number(item.settlementStatus)
  if (fulfillment === 2) return true
  if (fulfillment === 3 && settlement === 1) return true
  return false
}

export function countPendingApplications(applications) {
  return (applications || []).filter(isPendingApplication).length
}

export function countPendingInvitations(invitations) {
  return (invitations || []).filter(isPendingInvitation).length
}

export function countPendingOrders(orders) {
  return (orders || []).filter(isPendingOrder).length
}

export function recruitmentManageBadgeCount({ applications, invitations, orders } = {}) {
  return countPendingApplications(applications) + countPendingOrders(orders)
}

export function recruitmentHallRowBadgeCount(row = {}) {
  if (!row) return 0
  const hasPartCounts = row.pendingApplicationCount != null
    || row.pendingOrderCount != null
  if (hasPartCounts) {
    return (Number(row.pendingApplicationCount) || 0)
      + (Number(row.pendingOrderCount) || 0)
  }
  return Number(row.recruitmentManageBadgeCount) || 0
}

export function badgeValue(count) {
  const number = Number(count) || 0
  if (number <= 0) return ''
  return number > 99 ? '99+' : String(number)
}
